import axios from "axios";
import { ACCOUNT_ENUMS, userType } from "utils";

export const avatarService = {
  addAvatarService: (id, file) => {
    const path = userType === ACCOUNT_ENUMS.ADMIN ? "admins" : "employees";

    return axios.post(`/${path}/${id}/avatar`, file, { auth: true });
  },
  deleteAvatarService: (id) => {
    const path = userType === ACCOUNT_ENUMS.ADMIN ? "admins" : "employees";

    return axios.delete(`/${path}/${id}/avatar`, { auth: true });
  },
};
